import { navigate } from "gatsby"
import React, { useState } from "react"
import { siteUrl } from "../../../utils/siteUrl"
import "./nav-section-sub-menu.scss"

const NavSectionSubMenu = props => {
  var isPink = props.isPink
  const [isLog /*setLog*/] = useState(false)
  const [isShowSexologist, setIsShowSexologist] = useState(false)
  var absoluteUrl = siteUrl + "/"
  var todoSobreNosotrasLink = siteUrl + "/entre-nosotras/"
  var magazinLink = siteUrl + "/magazin/"
  const slugRedirect = slug => {
    window.location.href = absoluteUrl + slug
  }

  const persistRedirectTodoSobreNosotras = (slug, title) => {
    sessionStorage.setItem("slugFilter", slug)
    sessionStorage.setItem("titleFilter", title)
    window.location.href = todoSobreNosotrasLink + "cuidado-femenino/"
  }
  const persistRedirectMagazin = (slug, title) => {
    sessionStorage.setItem("slugFilterMagazin", slug)
    sessionStorage.setItem("titleFilterMagazin", title)
    window.location.href = magazinLink + "nuestro-mundo/"
  }

  const productRedirect = (sectionInfo, currentSectionSubMenu) => {
    window.location.href =
      "/" + currentSectionSubMenu.slug + "/" + sectionInfo.slug
  }

  const consultingRedirect = slug => {
    window.location.href = siteUrl + "/entre-nosotras/consultorios/" + slug
  }

  const calculateAge = () => {
    var today = new Date()
    var birthDate = new Date(
      JSON.parse(localStorage.getItem("USER_INFO")).birthdate.replace(/ /g, "T")
    )
    var age = today.getFullYear() - birthDate.getFullYear()
    var m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }

  React.useEffect(() => {
    if (
      process.env.LOCALE === "es-CO" &&
      localStorage.getItem("TOKEN_INFO") &&
      localStorage.getItem("USER_INFO") &&
      calculateAge() >= 18
    ) {
      setIsShowSexologist(true)
    }
  }, [])

  if (!props.mobile) {
    return (
      <div className={!isPink ? "f-sub-menu f-sub-pink" : "f-sub-menu"}>
        {props.activeSubMenu === 3 &&
          props.titles[0].slug === "productos/v-confident" && (
            <div className="f-v-confident">Línea Premenopausia</div>
          )}

        {props.titles.map((title, index) => {
          return (
            <a href={absoluteUrl + title.slug} key={index}>
              <h2 className="f-sub-menu-title" key={index}>
                {title.titulo}
              </h2>
            </a>
          )
        })}
        <ul>
          {props.sections &&
            props.sections.map((section, index) => {
              if (props.activeSubMenu === 2) {
                if (props.identify === 0) {
                  return (
                    <li
                      onClick={() => {
                        section.tieneRedireccion
                          ? (window.location.href =
                              siteUrl + section.redireccion)
                          : persistRedirectTodoSobreNosotras(
                              section.slug,
                              section.titulo
                            )
                      }}
                      className="f-section-item"
                      key={index}
                    >
                      {section.titulo}
                    </li>
                  )
                } else {
                  if (section.slug === "sexologa" && !isShowSexologist) {
                    return null
                  }
                  return (
                    <li
                      onClick={() => {
                        section.tieneRedireccion
                          ? (window.location.href =
                              siteUrl + section.redireccion)
                          : consultingRedirect(section.slug)
                      }}
                      className="f-section-item"
                      key={index}
                    >
                      {section.titulo}
                    </li>
                  )
                }
              } else if (props.activeSubMenu === 3) {
                return (
                  <li
                    onClick={() => {
                      section.tieneRedireccion
                        ? (window.location.href = section.redireccion)
                        : productRedirect(section, props.titles[0])
                    }}
                    className="f-section-item"
                    key={index}
                  >
                    {section.titulo}
                  </li>
                )
              } else if (props.activeSubMenu === 5) {
                //Verify if is the first subMenu of our world to handle subcategory

                return (
                  <li
                    onClick={() => {
                      section.tieneRedireccion
                        ? (window.location.href = siteUrl + section.redireccion)
                        : persistRedirectMagazin(section.slug, section.titulo)
                    }}
                    className="f-section-item"
                    key={index}
                  >
                    {section.titulo}
                  </li>
                )
              } else {
                if (isLog) {
                  return (
                    <li className="f-section-item" key={index}>
                      {section.titulo}
                    </li>
                  )
                } else {
                  if (section.slug === "sexologa" && !isShowSexologist) {
                    return null
                  } else {
                    return (
                      <li className="f-section-item" key={index}>
                        {section.titulo}
                      </li>
                    )
                  }
                }
              }
            })}
        </ul>
      </div>
    )
  } else {
    //mobile
    return (
      <>
        {props.titles.map((title, index) => {
          return (
            <li
              onClick={evt => {
                slugRedirect(title.slug)
              }}
              className="f-sub-menu-title-mobile"
              key={index}
            >
              <label className="f-text-title">{title.titulo}</label>
            </li>
          )
        })}
      </>
    )
  }
}

export default NavSectionSubMenu
